/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"
import FormSubmissionLink from "../FormSubmissionLink"

const RelatedFormSubmissionUpdatedAuditItemDetails = ({ audit }) => {
  const { auditedChanges, relatedFormSubmissionSlug } = audit
  const { discarded_at = [] } = auditedChanges

  const discarded = Boolean(discarded_at[1])

  if (discarded) {
    return (
      <div>
        Removed <FormSubmissionLink formSubmissionSlug={relatedFormSubmissionSlug} /> as a related form submission.
      </div>
    )
  }

  return (
    <div>
      Updated the form submission relationship with <FormSubmissionLink formSubmissionSlug={relatedFormSubmissionSlug} />.
    </div>
  )
}

RelatedFormSubmissionUpdatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default RelatedFormSubmissionUpdatedAuditItemDetails
